export const ONCE_PER_DAY = 86400;
export const ONCE_PER_EIGHT_HOURS = 28800;

/**
 * @deprecated Use `REVALIDATION_TAGS` from '@ngg/storefront-utils' instead.
 * The reason revalidation tags has been moved to the `@ngg/storefront-utils` package is because we wanted to share it between the different projects and Graph.
 * @todo Move the `REVALIDATION_TAGS` to the packages folder inside the monorepo when the Graph has been moved to the monorepo.
 */
export const REVALIDATION_TAGS = {
  // Contentful
  page: encodeURIComponent("page"),
  siteinfo: encodeURIComponent("siteinfo"),
  keyValue: encodeURIComponent("keyValue"),
  dictionary: encodeURIComponent("dictionary"),
  campaign: encodeURIComponent("campaign"),
  editorialPage: encodeURIComponent("editorialPage"),
  landingPage: encodeURIComponent("landingPage"),
  sideMenu: encodeURIComponent("sideMenu"),
  header: encodeURIComponent("header"),
  store: encodeURIComponent("store"),
  productPageInfo: encodeURIComponent("productPageInfo"),
  navigation: encodeURIComponent("navigation"),
  navigationLink: encodeURIComponent("navigationLink"),
  form: encodeURIComponent("form"),
  pageBySlug: (slug: string) => encodeURIComponent(`page:${slug}`),
  pageByType: (type: string) => encodeURIComponent(`pageType:${type}`),
  accordionRow: encodeURIComponent("accordionRow"),
  accordion: encodeURIComponent("accordion"),

  // Loop
  loopAll: encodeURIComponent("loop:all"),
  flags: encodeURIComponent("loop:flags"),
  productById: (id: string) => encodeURIComponent(`loop:productById:${id}`),
  productByMainURL: (url: string) =>
    encodeURIComponent(`loop:productByMainUrl:${url}`),
  brandByCode: (code: string) => encodeURIComponent(`loop:brandByCode:${code}`),
  designerByCode: (code: string) =>
    encodeURIComponent(`loop:designerByCode:${code}`),
  categoryByCode: (code: string) =>
    encodeURIComponent(`loop:categoryByCode:${code}`),
} as const;
